import React from "react";
import {
  ShieldCheck,
  PiggyBank,
  TrendingUp,
  Building2,
  CreditCard,
  Receipt,
  GraduationCap,
  Briefcase,
  Brain,
  ClipboardList,
} from "lucide-react";
import { services } from "../../mock";

const iconMap = {
  ShieldCheck,
  PiggyBank,
  TrendingUp,
  Building2,
  CreditCard,
  Receipt,
  GraduationCap,
  Briefcase,
  Brain,
  ClipboardList,
};

export default function Services() {
  return (
    <section id="services" className="py-20 bg-navy relative overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-gold/5 rounded-full blur-3xl pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-gold font-semibold tracking-[0.2em] uppercase text-sm">
            What We Offer
          </span>
          <h2 className="font-serif text-3xl sm:text-4xl font-bold text-white mt-3">
            Build, Grow &amp; Protect Your Legacy
          </h2>
          <p className="mt-4 text-gray-300 text-lg">
            Your path to financial freedom — comprehensive solutions tailored to
            your individual situation.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
          {services.map((s) => {
            const Icon = iconMap[s.icon] || ShieldCheck;
            return (
              <div
                key={s.id}
                className="group bg-navy-light/60 backdrop-blur rounded-xl p-6 border border-white/5 hover:border-gold/40 hover:bg-navy-light transition-all duration-300"
              >
                <div className="h-12 w-12 rounded-lg bg-gold/15 flex items-center justify-center group-hover:bg-gold transition-colors">
                  <Icon className="h-6 w-6 text-gold group-hover:text-navy transition-colors" />
                </div>
                <h3 className="mt-4 font-serif text-lg font-semibold text-white leading-snug">
                  {s.title}
                </h3>
                <p className="mt-2 text-gray-400 text-sm leading-relaxed">
                  {s.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
